import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class FrontTokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.getFrontToken() && request.url.indexOf('s3.') === -1) {
      request = request.clone({
        setHeaders: {
          Authorization: this.auth.getFrontToken()
        }
      });
    }
    return next.handle(request);
  }
}
